import { render, staticRenderFns } from "./lab-unit.vue?vue&type=template&id=27ce024d&scoped=true"
import script from "./lab-unit.vue?vue&type=script&lang=js"
export * from "./lab-unit.vue?vue&type=script&lang=js"
import style0 from "./lab-unit.vue?vue&type=style&index=0&id=27ce024d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ce024d",
  null
  
)

export default component.exports